import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    if (this.element.dataset.show === "true") {
      $("#item-modal").modal("show");
    }
  }
}
